export const OPEN_AVATAR_POPUP = '@@avatarPopup/open'
export const CLOSE_AVATAR_POPUP = '@@avatarPopup/close'

export const SET_AVATAR = '@@avatar/set'

export const CHOOSE_AVATAR_FILE = '@@avatar/chooseFile'
export const CLEAN_AVATAR_FILE = '@@avatar/cleanFile'
